<template lang="pug">
.analise-card(v-if='informacoes.length > 0')
    button-component.document.demonstrativo(     
        label='DEMONSTRATIVO',
        icon='mdi-file-pdf-box',
        color='red',
        background-color='white',
        border-color='red',
        @click.native='downloadDemonstrativoSicar()'
    )
    collapse-component.collapse(
        v-for='(info, i) in informacoes',
        :key='i',
        :title="`${informacoes.length - i}ª Análise`",
        :is-open="i === 0"
    )
        el-row.modal-content
            el-col.documents
                button-component.document(
                    v-for="(arquivo, index) in info.arquivos",
                    :key="index",
                    :label='arquivo.nome',
                    icon='mdi-file-pdf-box',
                    color='red',
                    background-color='white',
                    border-color='red',
                    @click.native='downloadDocumento(arquivo.caminho, `${arquivo.nome}.pdf`)'
                )
            el-col.analise-data
                .duracao-analise
                    p Duração total da análise: {{ info.duracaoTotal ? info.duracaoTotal + ' dia(s)' : '-' }}
                .dados
                    .title Dados da análise:
                    .data
                        p Data vinculação técnica: {{ info.vinculacaoTecnica | data }}
                        p Data do início da análise técnica: {{ info.inicioAnaliseTecnica | data }}
                        p Data da finalização da análise técnica: {{ info.finalizacaoAnaliseTecnica | data }}
                        p Data da validação da análise técnica: {{ info.validacaoAnaliseTecnica | data }}
                        p Duração da análise técnica: {{ info.duracaoAnalise ? info.duracaoAnalise + ' dia(s)' : '-' }}
</template>

<script>
import { buscarHistoricoPorCodigoImovel, downloadDocumento, downloadDemonstrativoSicar } from '@/services/processo.service';

export default {
    name: 'CardAnalise',

    props: {
        infoProcesso: Object,
    },

    data() {
        return {
            informacoes: [],
        };
    },

    async mounted() {
        this.informacoes = await buscarHistoricoPorCodigoImovel(this.infoProcesso.codigoImovel);
        await this.carregaArquivosParaDownload(this.informacoes);
    },

    methods: {
        async downloadDocumento(path, name) {
            const documento = await downloadDocumento(path);
            var file = window.URL.createObjectURL(new Blob([documento.data]));
            var docUrl = document.createElement('a');
            docUrl.href = file;
            docUrl.setAttribute('download', name);
            document.body.appendChild(docUrl);
            docUrl.click();
        },
        async downloadDemonstrativoSicar() {
            const documento = await downloadDemonstrativoSicar(this.infoProcesso.codigoImovel);
            let filename = documento?.headers['content-disposition'];                
            var file = window.URL.createObjectURL(new Blob([documento?.data]));
            var docUrl = document.createElement('a');
            docUrl.href = file;
            docUrl.setAttribute('download', filename);
            document.body.appendChild(docUrl);
            docUrl.click();
        },
        async carregaArquivosParaDownload(analises) {
            for (let analise of analises) {
                analise.arquivos = [];
                if (analise.caminhoTermoCompromisso)
                    analise.arquivos.push({nome: 'TERMO DE COMPROMISSO', caminho: analise.caminhoTermoCompromisso});

                if (analise.caminhoNotificacao)
                    analise.arquivos.push({nome: 'NOTIFICAÇÃO', caminho: analise.caminhoNotificacao});

                if (analise.caminhoDocumentoPrada)
                    analise.arquivos.push({nome: 'PRADA', caminho: analise.caminhoDocumentoPrada});

                if(analise.caminhoDocDemostrativoRegularidadeAmbiental){
                    analise.arquivos.push({nome: 'DEMONSTRATIVO DA REGULARIDADE AMBIENTAL', caminho: analise.caminhoDocDemostrativoRegularidadeAmbiental})
                }
            }
        }
    },
};
</script>

<style lang="scss">
.analise-card {
    color: var(--primary-black);

    max-height: 75vh;
    overflow-y: auto;

    .document {
        margin-bottom: 10px;
        width: fit-content !important;
        display: inline-flex !important;
        padding: 2px 8px;
    }

    .demonstrativo {
        margin: 15px 0px 12px 0px;
    }

    .collapse {
        margin-bottom: 12px;
    }

    .modal-content {
        display: flex; 
        justify-content: start;
    }
}

.documents {
    display: flex;
    flex-direction: column;
    min-height: 100px;
    margin: 6px;
}

.analise-data {
    min-height: 100px;
    font-size: 12px;
}

.analise-data .dados .title {
    font-weight: bolder;
}

.analise-data .dados {
    margin-top: 10px;
}

.analise-data .duracao-analise {
    font-weight: bolder;
}
</style>
